import React, { useState } from 'react';
import { Calendar, InterfaceEdit, Download2 } from '@combateafraude/icons/general';
import { useI18nFormatters } from 'hooks/i18nFormatters';
import { useTranslation } from 'react-i18next';
import { Button } from 'antd';
import { Link } from 'react-router-dom';
import PrintModal from './PrintModal';
import './styles.less';

const I18N_BASE_PATH = 'pages.private.KYBCompany.pages.companyDetails.header';

export const Header = ({ createdAt, updatedAt, companyData }) => {
  const [modalVisible, setModalVisible] = useState(false);
  const { t: translate } = useTranslation();
  const { i18nFormatDate } = useI18nFormatters();

  const handleToogleModal = () => setModalVisible(!modalVisible);

  return (
    <>
      <PrintModal
        modalVisible={modalVisible}
        handleToggleModal={handleToogleModal}
        companyData={companyData}
        createdAt={createdAt}
      />
      <div className="kyb-company-details-header-container">
        <div className="kyb-company-details-header-item">
          <h5 className="kyb-company-details-header-history">
            <Link to="/company?page=1&tab=history">
              <span>{translate(`${I18N_BASE_PATH}.history`, 'History')}</span> /{' '}
            </Link>
            {translate(`${I18N_BASE_PATH}.title`, 'Execution details')}
          </h5>
          <h5 className="kyb-company-details-header-title">
            {translate(`${I18N_BASE_PATH}.title`, 'Execution details')}
          </h5>
          <div className="kyb-company-details-header-box">
            <div>
              <Calendar className="kyb-company-details-header-icon" />
              {translate(`${I18N_BASE_PATH}.createdAt`, 'Date created')}{' '}
              {i18nFormatDate(createdAt, 'default')}
            </div>
            <div>
              <InterfaceEdit className="kyb-company-details-header-icon" />
              {translate(`${I18N_BASE_PATH}.updatedAt`, 'Last modified')}{' '}
              {i18nFormatDate(updatedAt, 'default')}
            </div>
          </div>
        </div>
        <div className="kyb-company-details-header-item">
          <Button shape="round" onClick={handleToogleModal}>
            <Download2 />
            <span>{translate(`${I18N_BASE_PATH}.saveAsPDF`, 'Save as PDF')}</span>
          </Button>
        </div>
      </div>
    </>
  );
};
